import React, { useState } from "react";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaGoogle } from "react-icons/fa";
import Logo from "../Assets/tit-logo.png";
import Logo2 from "../Assets/unb-plac.png";
import AboutUs from "./AboutUs";
import AdvisoryBoard from "./AdvisoryBoard";
import { IoMenu } from "react-icons/io5";

const NavBar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const btnclick = () => {
    setShowMenu(!showMenu);
  };

  return (
    <>
      <nav>
        <div className="hero-nav">
          <ul>
            <li>
              <a href="#About">About Us</a>
            </li>
            <li>
              <a href="#advisory">Advisory Board</a>
            </li>
            <li>
              <a href="#OurTeam">Our Team</a>
            </li>
            <li>
              <a href="#inst">Institutes</a>
            </li>
            <li>
              <a href="#programID">Programs</a>
            </li>
            <li>
              <a href="#">Alumni</a>
            </li>
            <li>
              <a href="#">Blog</a>
            </li>
            <li>
              <a href="#">Login</a>
            </li>
            <li>
              <a href="#">Admission Enquiry</a>
            </li>
          </ul>
        </div>
        <div className="hero-icons">
          <ul>
            <li>
              <a href="#">
                <FaInstagram />
              </a>
            </li>
            <li>
              {" "}
              <a href="#">
                <FaFacebookF />
              </a>
            </li>
            <li>
              <a href="#">
                {" "}
                <FaLinkedinIn />
              </a>
            </li>
            <li>
              <a href="#">
                <FaTwitter />
              </a>
            </li>
            <li>
              <a href="#">
                {" "}
                <FaGoogle />
              </a>
            </li>
          </ul>
          <button type="button">Notices</button>
        </div>
      </nav>
      
        <div className="nav2">
          <div className="clg-logo">
            <a href="#">
              <img src={Logo} alt="College Logo" />
            </a>
          </div>
          <div className={showMenu ? "menu-mobile" : "menu-web"}>
         
            <ul>
              <li>
                <a href="#">Placements</a>
              </li>
              <li>
                <a href="#">Life@Technocrats</a>
              </li>
              <li>
                <a href="#">Group Intake</a>
              </li>
              <li>
                <a href="#">Contact Us</a>
              </li>
            </ul>
         
          </div>
          <div className="nav2-img">
            <img src={Logo2} alt="" />
          </div>
          <div className="ham-menu">
            <button onClick={btnclick}>
              <IoMenu />
            </button>
          </div>
        </div>
      
    </>
  );
};

export default NavBar;
